// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper__inner-14DBq";
var _4 = "image-11spA";
var _5 = "icon-3sql9";
var _6 = "context-1majU";
var _7 = "action-3eUom";
var _8 = "content__wrapper-395E3";
var _9 = "content-1XIRD";
var _a = "title-2H_Gv";
var _b = "text-1Qb8g";
var _c = "wrapper-mzwuD";
var _d = "global-sdTJR";
var _e = "info-1mJFJ";
var _f = "success-2DlZ4";
var _10 = "warning-3UPu6";
var _11 = "subscription-3zUGE";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper__inner", _4 as "image", _5 as "icon", _6 as "context", _7 as "action", _8 as "content__wrapper", _9 as "content", _a as "title", _b as "text", _c as "wrapper", _d as "global", _e as "info", _f as "success", _10 as "warning", _11 as "subscription" }
export default { "__esModule": _1, "mobile": _2, "wrapper__inner": _3, "image": _4, "icon": _5, "context": _6, "action": _7, "content__wrapper": _8, "content": _9, "title": _a, "text": _b, "wrapper": _c, "global": _d, "info": _e, "success": _f, "warning": _10, "subscription": _11 }
